export default "__VITE_ASSET__DkKp2Ae$__"